import React from 'react';
import Modal, { ModalSize } from './Modal';

interface DeleteModalProps {
  modalClassName?: string;
  children: React.ReactNode;
  modalMain?: string;
  size?: ModalSize;
  onClick?: () => void;
  closeButtonCLick?: () => void;
}

const DeleteModal = React.forwardRef<HTMLDivElement, DeleteModalProps>(({
  children,
  ...props
}, ref) => {
  return (
    <Modal ref={ref} {...props}>
      {children}
    </Modal>
  );
});

export default DeleteModal;
